import { Component, OnInit } from '@angular/core';
import { IPermission, IRole, IUser } from 'src/app/models';
import { AlertsService } from 'src/app/services/alerts.service';
import { PermissionService } from 'src/app/services/permission.service';
import { RoleService } from 'src/app/services/role.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ALERTS } from 'src/app/common';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { UserService } from 'src/app/services/user.service';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {

  users: IUser[];
  asigRoles: IRole[];
  disRoles: IRole[];
  roles: IRole[];

  selectedUser!: IUser;

  constructor(
    private userService: UserService,
    private roleService: RoleService,
    private alertsService: AlertsService,
    
    library: FaIconLibrary
  ) {
    library.addIcons(faArrowLeft, faArrowRight)
    this.users = [];
    this.asigRoles =[];
    this.disRoles = [];
    this.roles = [];
  }

  ngOnInit(): void {
    this.onLoad();
  }

  drop(event: CdkDragDrop<IRole[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
      this.updateUserRoles();
    }
  }

  onLoad() {
    this.loadUsers();
    this.loadRoles();
  }

  active(user: IUser){
    if(!this.selectedUser) return false
    return (this.selectedUser == user)
  }

  loadUsers(){
    this.userService.GetUsers().subscribe(res => {
      if(res.Result){
        this.users = [];
        res.Data.forEach(x => { if(x.Active) this.users.push(x)})
        if(this.users.length > 0) this.updateUserSelection(this.users[0])
      }
    },
    err => {
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
    })
  }

  loadRoles(){
    this.roleService.GetRoles().subscribe(res => {
      if(res.Result){
        this.roles = [];
        res.Data.forEach(x => { if(x.Active) this.roles.push(x)})
      }
    },
    err => {
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
    })
  }

  loadRolesByUser(user: IUser){
    if(user){
      this.roleService.GetRolesByUser(user).subscribe(res => {
        if(res.Result){
          this.asigRoles = [];
          this.disRoles = [];
          this.roles.forEach(x => {
            if(res.Data.find(y => y.RoleId == x.Id)) this.asigRoles.push(x)
            else this.disRoles.push(x)
          })
        }
      },
      err => {
        this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
      })
    }
  }

  updateUserRoles(){
    let roleIds = this.asigRoles.map(x => x.Id)
    this.roleService.UpdateRolesByUser(roleIds, this.selectedUser.Id)
    .subscribe(
      res => {
        if(res.Result) this.alertsService.ShowSmallCornerAlert('Roles actualizados', ALERTS.success)
        else this.alertsService.ShowSmallCornerAlert(res.ErrorInfo.Message, ALERTS.error)
      },
      err => {
        this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
    });
  }

  clearSelectedUser(){
    this.selectedUser = undefined as any;
    this.asigRoles = [];
    this.disRoles = [];
  }

  updateUserSelection(user: IUser){
    this.selectedUser = user;
    this.loadRolesByUser(this.selectedUser)
  }

  setAllRoles(){
    this.asigRoles = this.asigRoles.concat(this.disRoles.splice(0, this.disRoles.length))
    this.updateUserRoles();
  }

  unsetAllRoles(){
    this.disRoles = this.disRoles.concat(this.asigRoles.splice(0, this.asigRoles.length))
    this.updateUserRoles();
  } 
}
